import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { RESPONSE_COLUMN_LABEL_KEYS } from "../campaigns.constants";
import { ResponseGridHeaderRow } from "./campaign-response-grid";
import { CampaignResponseRow } from "./campaign-response-row";
import type { AssetRow } from "../hooks/use-campaign-response-form.hook";
import type { CampaignResponseValue } from "../response-options";

interface CampaignResponseTableProps {
  rows: AssetRow[];
  responses: Record<string, CampaignResponseValue>;
  remarks: Record<string, string>;
  rowsMissingRequiredRemarks: ReadonlySet<string>;
  isReadOnly: boolean;
  onResponseChange: (rowKey: string, value: CampaignResponseValue) => void;
  onRemarksChange: (rowKey: string, value: string) => void;
}

const CampaignResponseTableHeader: FC = () => (
  <ResponseGridHeaderRow role="row">
    <Col role="columnheader">
      <Text fontWeight="bold">{getString(RESPONSE_COLUMN_LABEL_KEYS.serialNumber)}</Text>
    </Col>
    <Col role="columnheader">
      <Text fontWeight="bold">{getString(RESPONSE_COLUMN_LABEL_KEYS.model)}</Text>
    </Col>
    <Col role="columnheader">
      <Text fontWeight="bold">{getString(RESPONSE_COLUMN_LABEL_KEYS.deviceStatus)}</Text>
    </Col>
    <Col role="columnheader">
      <Text fontWeight="bold">{getString(RESPONSE_COLUMN_LABEL_KEYS.remarks)}</Text>
    </Col>
  </ResponseGridHeaderRow>
);

export const CampaignResponseTable: FC<CampaignResponseTableProps> = ({
  rows,
  responses,
  remarks,
  rowsMissingRequiredRemarks,
  isReadOnly,
  onResponseChange,
  onRemarksChange,
}) => (
  <Col role="table" gridGap="S200">
    <CampaignResponseTableHeader />
    {rows.map((row) => (
      <CampaignResponseRow
        key={row.key}
        asset={row.asset}
        value={responses[row.key] ?? ""}
        remarks={remarks[row.key] ?? ""}
        isRemarksMissing={rowsMissingRequiredRemarks.has(row.key)}
        disabled={isReadOnly}
        onResponseChange={(value) => onResponseChange(row.key, value)}
        onRemarksChange={(value) => onRemarksChange(row.key, value)}
      />
    ))}
  </Col>
);
